module.exports = __webpack_public_path__ + "img/build-api-without-swagger.bf636d79.png";